module.exports = {"BASE_URL":"https://chatbot.tp.or.kr","BASE_URL_SERVER":"http://10.1.1.3:8080","BASE_URL_MOBILE":"https://chatbot.tp.or.kr","REST_API_PATH":"/restapi","MBR_REST_API_PATH":"","PATH":"/chatbot","REPO_ID":"TP","AGENT_NAME":"사학연금챗봇","FAQ_CATEGORY_NAME":"사학연금챗봇","LOGIN_USE":false,"USER_ID":"","CRYPTO_KEY":"secret-key-1","HOMEPAGE_URL":"https://www.tp.or.kr","HOMLOGIN_URI":"https://www.tp.or.kr/tp-kr/pgm/i-508/login/front/login-step1.do","PENSIONHOME_URI":"https://cpension.tp.or.kr","PENSIONMOBILE_URI":"http://www.tp.or.kr:8083","PENSIONMOBILE_URI1":"http://218.38.130.43:8083"}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = 14
// module chunks = 0